import { useEffect, useState } from 'react';
import { Alert, Box, Chip, CircularProgress, Paper, Table, TableBody, TableCell, TableHead, TableRow, ToggleButton,
  ToggleButtonGroup, Typography } from '@mui/material';
import { apiService, EvidenceData } from '../services/api';
import { VERDICT_COLOR } from '../components/EvidenceBadge';

export default function Evidence() {
  const [data, setData] = useState<EvidenceData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [filter, setFilter] = useState<string>('all');
  useEffect(() => { apiService.getEvidence().then(setData).catch(e => setError(e?.message || 'Failed to load')); }, []);

  const rows = data ? data.entries.filter(e => filter === 'all' || e.verdict === filter) : [];
  return (
    <Box sx={{ p: { xs: 1, sm: 3 } }}>
      <Typography variant="h4" fontWeight={700} gutterBottom>Evidence</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 900 }}>
        Every claim the app's pages make, the test behind it and what came out. <b>Proven</b> means it survived the
        multiple-testing check (or a calibration test) and held in both halves of the history. <b>Promising</b> means
        positive but not clear yet. <b>No edge</b> means tested and no better than chance, random picks or "always up".
        Each page shows its own verdicts in the top bar.
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {!data && !error && <CircularProgress />}
      {data && (
        <>
          <ToggleButtonGroup size="small" exclusive value={filter} onChange={(_, v) => v && setFilter(v)} sx={{ mb: 2, flexWrap: 'wrap' }}>
            <ToggleButton value="all">All ({data.entries.length})</ToggleButton>
            {Object.entries(data.verdicts).map(([k, label]) => (
              <ToggleButton key={k} value={k}>{label} ({data.entries.filter(e => e.verdict === k).length})</ToggleButton>
            ))}
          </ToggleButtonGroup>
          <Paper sx={{ overflowX: 'auto' }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Verdict</TableCell><TableCell>Claim</TableCell><TableCell>Test</TableCell>
                  <TableCell>Result</TableCell><TableCell>Pages</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(e => (
                  <TableRow key={e.id} hover sx={{ verticalAlign: 'top' }}>
                    <TableCell>
                      <Chip size="small" label={data.verdicts[e.verdict]} sx={{ bgcolor: `${VERDICT_COLOR[e.verdict]}22`, color: VERDICT_COLOR[e.verdict], fontWeight: 700 }} />
                    </TableCell>
                    <TableCell sx={{ minWidth: 200 }}><Typography variant="body2" fontWeight={600}>{e.claim}</Typography></TableCell>
                    <TableCell sx={{ minWidth: 220 }}><Typography variant="caption">{e.test}</Typography></TableCell>
                    <TableCell sx={{ minWidth: 260 }}>
                      <Typography variant="body2">{e.result}</Typography>
                      <Typography variant="caption" color="text.secondary">docs/features/{e.doc}</Typography>
                    </TableCell>
                    <TableCell><Typography variant="caption">{e.pages.join(' ')}</Typography></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </>
      )}
    </Box>
  );
}
